import { makeStyles } from "@material-ui/core/styles";
import {
  primary,
  grey300,
  secondary,
} from "../../../assets/variables.module.scss";

const useStyles = makeStyles((theme) => ({
  container: {
    width: "65vw",
  },
  benefitImage: {
    width: "50%",
  },
  tooltipContainer: {
    padding: `${theme.spacing(2)}px 0`,
  },
  divider: {
    height: 1,
    backgroundColor: grey300,
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  sliderContainer: {
    padding: `${theme.spacing(2)}px 0 ${theme.spacing(4)}px 0`,
  },
  infoIcon: {
    marginRight: theme.spacing(1),
  },
  radio: {
    width: theme.spacing(2),
    height: theme.spacing(2),
    color: secondary,
    marginRight: theme.spacing(1),
    cursor: "pointer",
  },
  checkedRadio: {
    color: primary,
  },
  radioText: {
    cursor: "pointer",
  },
  activeRadioText: {
    color: primary,
    cursor: "pointer",
  },
  row: {
    padding: `${theme.spacing(1)}px 0`,
  },
}));

export default useStyles;
